import { DTO__base } from '@shared/common/DTO__base';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { logi } from '../utils_logs';
import { timestamp_ms } from '../utils_time';

export class DTOPerformaceCapture extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.PERFORMANCE_CAPTURE;

  /*
   * FIELDS
   */

  id!: string;
  label!: string;
  timestamp_start!: number;
  timestamp_end!: number;
  duration!: number;
  performance_reference!: number;
  log_entry_id!: number;
  /*
   * METHODS
   */

  constructor() {
    super();
    this.log_entry_id = NaN;
  }

  measure() {
    if (this.is_stub()) return;

    this.timestamp_end = timestamp_ms();
    this.duration = this.timestamp_end - this.timestamp_start;
  }

  measure_and_log_with_request_status(is_aborted: boolean) {
    if (is_aborted) return;

    this.measure_and_log();
  }

  measure_and_log() {
    if (this.is_stub()) return;

    this.measure();

    //todo: add condition

    let { log_entry_id } = this;

    logi(`⏱\t\t${this.label}`, { performance_capture: this, log_entry_id, namespace: ELoggerNamespaceShared.PERFORMANCE_CAPTURE });
  }

  check_possible_infinity_loop() {
    //todo: implement
  }

  assert_standard_fields(): void {
    //do nothing
  }
}
